/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package coreui.theme

import coreui.util.color

val md_theme_light_primary = color(0xFF1D5FA6)
val md_theme_light_onPrimary = color(0xFFFFFFFF)
val md_theme_light_primaryContainer = color(0xFFD4E3FF)
val md_theme_light_onPrimaryContainer = color(0xFF001C3A)
val md_theme_light_secondary = color(0xFF545F71)
val md_theme_light_onSecondary = color(0xFFFFFFFF)
val md_theme_light_secondaryContainer = color(0xFFD8E3F8)
val md_theme_light_onSecondaryContainer = color(0xFF111C2B)
val md_theme_light_tertiary = color(0xFF6D5676)
val md_theme_light_onTertiary = color(0xFFFFFFFF)
val md_theme_light_tertiaryContainer = color(0xFFF7D8FF)
val md_theme_light_onTertiaryContainer = color(0xFF271430)
val md_theme_light_error = color(0xFFBA1A1A)
val md_theme_light_errorContainer = color(0xFFFFDAD6)
val md_theme_light_onError = color(0xFFFFFFFF)
val md_theme_light_onErrorContainer = color(0xFF410002)
val md_theme_light_background = color(0xFFFDFCFF)
val md_theme_light_onBackground = color(0xFF1A1C1E)
val md_theme_light_surface = color(0xFFFDFCFF)
val md_theme_light_onSurface = color(0xFF1A1C1E)
val md_theme_light_surfaceVariant = color(0xFFE0E2EC)
val md_theme_light_onSurfaceVariant = color(0xFF43474E)
val md_theme_light_outline = color(0xFF74777F)
val md_theme_light_inverseOnSurface = color(0xFFF1F0F4)
val md_theme_light_inverseSurface = color(0xFF2F3033)
val md_theme_light_inversePrimary = color(0xFFA5C8FF)
val md_theme_light_shadow = color(0xFF000000)
val md_theme_light_surfaceTint = color(0xFF1D5FA6)
val md_theme_light_outlineVariant = color(0xFFC3C6CF)
val md_theme_light_scrim = color(0xFF000000)

val md_theme_dark_primary = color(0xFFA5C8FF)
val md_theme_dark_onPrimary = color(0xFF00315E)
val md_theme_dark_primaryContainer = color(0xFF004785)
val md_theme_dark_onPrimaryContainer = color(0xFFD4E3FF)
val md_theme_dark_secondary = color(0xFFBCC7DC)
val md_theme_dark_onSecondary = color(0xFF263141)
val md_theme_dark_secondaryContainer = color(0xFF3D4758)
val md_theme_dark_onSecondaryContainer = color(0xFFD8E3F8)
val md_theme_dark_tertiary = color(0xFFDABDE2)
val md_theme_dark_onTertiary = color(0xFF3D2946)
val md_theme_dark_tertiaryContainer = color(0xFF553F5E)
val md_theme_dark_onTertiaryContainer = color(0xFFF7D8FF)
val md_theme_dark_error = color(0xFFFFB4AB)
val md_theme_dark_errorContainer = color(0xFF93000A)
val md_theme_dark_onError = color(0xFF690005)
val md_theme_dark_onErrorContainer = color(0xFFFFDAD6)
val md_theme_dark_background = color(0xFF1A1C1E)
val md_theme_dark_onBackground = color(0xFFE3E2E6)
val md_theme_dark_surface = color(0xFF1A1C1E)
val md_theme_dark_onSurface = color(0xFFE3E2E6)
val md_theme_dark_surfaceVariant = color(0xFF43474E)
val md_theme_dark_onSurfaceVariant = color(0xFFC3C6CF)
val md_theme_dark_outline = color(0xFF8D9199)
val md_theme_dark_inverseOnSurface = color(0xFF1A1C1E)
val md_theme_dark_inverseSurface = color(0xFFE3E2E6)
val md_theme_dark_inversePrimary = color(0xFF1D5FA6)
val md_theme_dark_shadow = color(0xFF000000)
val md_theme_dark_surfaceTint = color(0xFFA5C8FF)
val md_theme_dark_outlineVariant = color(0xFF43474E)
val md_theme_dark_scrim = color(0xFF000000)

val seed = color(0xFF1F60A6)